import { z } from "zod"

export const createSchema = z.object({
  code: z.string().min(1, { message: 'Campo obrigatório' }).max(3, { message: 'Tamanho máximo: 3 caracteres' }),
  name: z.string().min(3, { message: 'Tamanho mínimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  account_validation_regex: z.string().optional().nullable(),
  branch_validation_regex: z.string().optional().nullable(),
})

export const updateSchema = z.object({
  code: z.string().min(1, { message: 'Campo obrigatório' }).max(3, { message: 'Tamanho máximo: 3 caracteres' }),
  name: z.string().min(3, { message: 'Tamanho mínimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  account_validation_regex: z.string().min(1, { message: 'Campo obrigatório' }),
  branch_validation_regex: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type BankInstitutionValidationSchema = z.infer<typeof createSchema>
export type UpdateBankInstitutionValidationSchema = z.infer<typeof updateSchema>
